import React from 'react'
import PropTypes from 'prop-types'

import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'

import moment from 'moment'

import LineItemsDetailsDaySelector from './LineItemsDetailsDaySelector'
import modeArrow from 'resources/line_items_details_arrow_down.png'

export default class LineItemsDetailsContentPanel extends React.Component {

  static propTypes = {
    mode: PropTypes.string.isRequired,
    dateStr: PropTypes.string,
    jobInfo: PropTypes.shape().isRequired,
    onModeSelectorChanged: PropTypes.func.isRequired,
    onSelectedDayChanged: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      mode: this.props.mode,
      openModeOptions: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.mode !== nextProps.mode
      || this.props.dateStr !== nextProps.dateStr) {
      this.setState({
        mode: nextProps.mode,
        dateStr: nextProps.dateStr
      })
    }
  }

  handleModeClicked = (event) => {
    event.preventDefault()
    this.setState({
      openModeOptions: true,
      anchorElement: event.currentTarget
    })
  }

  handleModeOptionsClosed = () => {
    this.setState({
      openModeOptions: false
    })
  }

  handleModeSelection = (selection) => {
    this.props.onModeSelectorChanged(selection)
    this.setState({
      openModeOptions: false
    })
  }

  handleDaySelectorChanged = (dateStr) => {
    this.props.onSelectedDayChanged(dateStr)
  }

  getModeDisplay = () => {
    return this.state.mode === 'day'
      ? 'Day'
      : 'Total'
  }

  format = (date) => {
    return date.format('MMM Do')
  }

  getDaysRange = () => {
    const startDate = moment(this.props.jobInfo.startDate)
    const endDate = moment(this.props.jobInfo.endDate)
    return `${this.format(startDate)} - ${this.format(endDate)}`
  }

  render() {
    return (
      <div style={styles.container}>
        <div />
        { this.state.mode === 'day'
          ? <LineItemsDetailsDaySelector
            jobInfo={this.props.jobInfo}
            dateStr={this.props.dateStr}
            onDaySelectorChanged={this.handleDaySelectorChanged}/>
          : <div style={styles.dayRange}>{this.getDaysRange()}</div>
        }
        <div style={styles.mode} onClick={this.handleModeClicked}>
          <div style={styles.modeDisplay}>{this.getModeDisplay()}</div>
          <img src={modeArrow} width={12} height={12} title='Mode' />
          <Popover
            open={this.state.openModeOptions}
            anchorEl={this.state.anchorElement}
            anchorOrigin={{horizontal: 'middle', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'bottom'}}
            onRequestClose={this.handleModeOptionsClosed}>
            <Menu>
              <MenuItem
                key={1}
                onTouchTap={() => this.handleModeSelection('day')}
                primaryText='Day' />
              <MenuItem
                key={2}
                onTouchTap={() => this.handleModeSelection('total')}
                primaryText='Total' />
            </Menu>
          </Popover>
        </div>
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '7px 12px 7px 12px'
  },

  mode: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 6,
    paddingBottom: 6,
    borderRadius: 4,
    cursor: 'pointer',
    border: 'solid 1px #686565'
  },

  modeDisplay: {
    fontSize: 14,
    marginRight: 14
  },

  dayRange: {
    fontSize: 18
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/lineItems/LineItemsDetailsContentPanel.js